import React from "react";

function LaunchPlanIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 23.9945C0 10.7427 10.7427 0 23.9945 0C37.2464 0 47.9891 10.7427 47.9891 23.9945C47.9891 37.2464 37.2464 47.9891 23.9945 47.9891C10.7427 47.9891 0 37.2464 0 23.9945Z"
        fill="#F1F5F9"
      />
      <path
        d="M21.9224 27.4937C21.8332 27.1477 21.6528 26.832 21.4002 26.5793C21.1475 26.3267 20.8318 26.1463 20.4858 26.0571L14.3522 24.4754C14.2475 24.4457 14.1554 24.3827 14.0898 24.2959C14.0243 24.2091 13.9888 24.1033 13.9888 23.9945C13.9888 23.8857 14.0243 23.7799 14.0898 23.6931C14.1554 23.6064 14.2475 23.5433 14.3522 23.5136L20.4858 21.931C20.8316 21.8418 21.1473 21.6616 21.4 21.4092C21.6526 21.1567 21.833 20.8411 21.9224 20.4953L23.5041 14.3617C23.5335 14.2567 23.5964 14.1641 23.6834 14.0982C23.7703 14.0322 23.8764 13.9966 23.9855 13.9966C24.0946 13.9966 24.2007 14.0322 24.2876 14.0982C24.3745 14.1641 24.4375 14.2567 24.4669 14.3617L26.0475 20.4953C26.1368 20.8413 26.3171 21.1571 26.5698 21.4097C26.8224 21.6624 27.1382 21.8427 27.4842 21.932L33.6178 23.5126C33.7233 23.5417 33.8163 23.6046 33.8826 23.6917C33.9488 23.7787 33.9847 23.8851 33.9847 23.9945C33.9847 24.1039 33.9488 24.2103 33.8826 24.2974C33.8163 24.3844 33.7233 24.4473 33.6178 24.4764L27.4842 26.0571C27.1382 26.1463 26.8224 26.3267 26.5698 26.5793C26.3171 26.832 26.1368 27.1477 26.0475 27.4937L24.4659 33.6273C24.4365 33.7324 24.3735 33.8249 24.2866 33.8909C24.1997 33.9568 24.0936 33.9925 23.9845 33.9925C23.8754 33.9925 23.7693 33.9568 23.6824 33.8909C23.5954 33.8249 23.5325 33.7324 23.5031 33.6273L21.9224 27.4937Z"
        stroke="#45556C"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9834 14.9966V18.9966"
        stroke="#45556C"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.9839 16.9961H29.9839"
        stroke="#45556C"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9868 28.9934V30.9934"
        stroke="#45556C"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9873 29.9932H14.9873"
        stroke="#45556C"
        strokeWidth="1.99954"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LaunchPlanIcon;
